export const TERMS_OF_SERVICES_URL =
  'https://www.getbento.com/reservations-diner-terms/';

export const PRIVACY_POLICY_URL = 'https://www.getbento.com/privacy/';

export const CI_PORT_QUERY_KEY = 'ci-port';

export const MEDIA_URL = 'https://media-cdn.getbento.com';
